import React, { Component } from 'react';

class KPIDisplay extends Component {
  render() {
    let {values}=this.props.component;

    return (
      <div className={`form-group nopadding ${this.props.component.widths.parent}`}>
        <div className="col-sm-12 kpimainval nopadding">{values.main.val}</div>
        <div className="col-sm-12 kpimaindesc nopadding">{values.main.desc}</div>
        <div className="col-sm-12 kpisub nopadding">{`${values.sub.val} ${values.sub.desc}`}</div>
      </div>
    );
  }
}

export default KPIDisplay;